import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteDiscountCode } from '../../../../actions/sales/DiscountCode';

const DiscountCodeDeleteButton = ({
  dispatchDeleteDiscountCode,
  discountCodeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteDiscountCode({ discountCodeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

DiscountCodeDeleteButton.propTypes = {
  dispatchDeleteDiscountCode: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  discountCodeId: PropTypes.number.isRequired,
};

DiscountCodeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteDiscountCode: deleteDiscountCode,
};

export default connect(null, mapDispatchToProps)(DiscountCodeDeleteButton);
